import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

/**
 * - `full`  — the complete Delta format experience (OneLake Files only, see {@link deltaMetadata}).
 * - `clone` — the restricted schema-agnostic binary clone (the stores in {@link deltaCloneLinkedServiceTypes}).
 */
export type DeltaTier = 'none' | 'full' | 'clone';

/** Backs {@link deltaMetadata}'s `supportLinkedServiceTypes`; kept here so tier resolution stays import-light. */
export const deltaFullLinkedServiceTypes: string[] = [adfModelTypeMap.oneLakeFile.linkedServiceType];

/**
 * OneLake Files is listed here too: the connector and full Delta support ship on separate flags, so it has to
 * be clone-capable on its own. Tier resolution tries the full tier first, so full support wins where both ship.
 */
export const deltaCloneLinkedServiceTypes: string[] = [
    adfModelTypeMap.azureBlobFS.linkedServiceType,
    adfModelTypeMap.lakehouse.linkedServiceType,
    adfModelTypeMap.amazonS3.linkedServiceType,
    adfModelTypeMap.amazonS3Compatible.linkedServiceType,
    adfModelTypeMap.googleCloudStorage.linkedServiceType,
    adfModelTypeMap.oracleCloudStorage.linkedServiceType,
    adfModelTypeMap.oneLakeFile.linkedServiceType
];
